import {
  getString,
} from "@surya-digital/leo-ts-types";

export interface KeycloakEmailDTO {
  email: string;
}

export class KeycloakEmail {
  readonly isKeycloakEmailKeycloakEmail: boolean = true;

  readonly email: string;


  constructor(
  email: string
  ) {
    KeycloakEmail.validateEmail(email);
    this.email = email;
  }

  static fromDTO(dto: KeycloakEmailDTO): KeycloakEmail {
    const email = getString(dto, "email", InvalidKeycloakEmailEmailError);
    return new KeycloakEmail(
      email
    );
  }

  toDTO(): KeycloakEmailDTO {
    const dto: KeycloakEmailDTO = {
        email: this.email
    };
    return dto;
  }
  private static validateEmail = (email: string): void => {
    if(email.trim().length === 0) {
      throw new InvalidKeycloakEmailEmailNonEmptyError(
        `Attribute email cannot be an empty string.`
      );
    }
  }
  
}

KeycloakEmail.prototype.toString = function toString(): string {
  return `KeycloakEmail(email='${this.email}')`;
};

export class InvalidKeycloakEmailError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidKeycloakEmailError";
  }
}
export class InvalidKeycloakEmailEmailError extends InvalidKeycloakEmailError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidKeycloakEmailEmailError";
  }
}

export class InvalidKeycloakEmailEmailMatchesError extends InvalidKeycloakEmailEmailError {
  readonly matches: string;
  constructor(matches: string, message?: string) {
    super(message);
    this.matches = matches;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidKeycloakEmailEmailMatchesError";
  }
}

export class InvalidKeycloakEmailEmailNonEmptyError extends InvalidKeycloakEmailEmailError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidKeycloakEmailEmailNonEmptyError";
  }
}
